import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { AutomationId } from 'utils/automationUtil'
import { SocialWebBrandPassionIndexWidget } from 'schemas/SocialWebBrandPassionIndexWidgetSchema'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import BubbleDisplayOptions from 'enums/BubbleDisplayOptions'
import resolveBubbleData from './utils/bubbleDataResolver'
import { Bubble } from './Bubble'

const StyledWidgetContainer = styled.div`
  height: 99%;
  display: flex;
  flex-direction: column;
`

const StyledBubbleContainer = styled.div`
  flex: 1;
`

const StyledInformation = styled.div`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.regular};
  text-align: center;
  padding-top: 10px;
`

interface BrandPassionIndexProps {
  widgetId: number
}

const BrandPassionIndex = ({ widgetId }: BrandPassionIndexProps): React.ReactElement => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  const searchResult = useDashboardWidgetData<AnnotatedMetricResult>(widgetId)
  const widgetSetting = useDashboardWidgetSetting<SocialWebBrandPassionIndexWidget>(widgetId)
  const { topicInfos, displayOption, trendOption, timeInterval } = widgetSetting

  const shouldShowPriorPeriodsMessage = trendOption !== undefined && trendOption > 0
  const bubbleData = resolveBubbleData(searchResult, topicInfos!)

  return (
    <StyledWidgetContainer>
      <StyledBubbleContainer>
        <Bubble
          bubbleData={bubbleData}
          displayOption={displayOption || BubbleDisplayOptions.BUBBLES}
          timeInterval={timeInterval!}
        />
      </StyledBubbleContainer>
      {shouldShowPriorPeriodsMessage && (
        <StyledInformation mode={theme} data-testId={AutomationId.bubble.priorMessage}>
          ({t('priorPeriodsMessage')})
        </StyledInformation>
      )}
    </StyledWidgetContainer>
  )
}

export default BrandPassionIndex
